export const brandRadius = {
  small: 4,
  medium: 8,
  large: 12,
} as const;
